import React, { useState, useRef, useEffect } from 'react';
import {SketchPicker} from "react-color";
import {FormattedMessage} from "react-intl";
import Button from "@mui/material/Button";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const BackgroundColorPicker = ({ color, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const pickerRef = useRef(null);
  const buttonRef = useRef(null);

  // Close picker when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pickerRef.current &&
        !pickerRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const togglePicker = () => setIsOpen((prev) => !prev);

  return (
    <Button className={"ui-button2 ui-button2--medium ui-button2--primary-border"}
            ref={buttonRef}
            style={{
              backgroundColor: color,
              padding: '8px 12px',
              boxShadow: '0 0 4px rgba(0,0,0,0.3)',
              border: '1px solid #ffffff',
              //textTransform: 'сфзшефдшяу'
            }}
            endIcon={<ArrowDropDownIcon />}
            onClick={() => togglePicker()}>
      <FormattedMessage id="sqft.ar3d.background.changeBackground"/>
      {isOpen && (
        <div className="background-color-picker__popover" ref={pickerRef}>
          <SketchPicker color={color} onChange={onChange} />
        </div>
      )}
    </Button>
  );
};

export default BackgroundColorPicker;
